/** Italian locale + Europe/Rome — use for every user-visible date/time in the app. */
export const APP_LOCALE = "it-IT";
export const APP_TIMEZONE = "Europe/Rome";

const TZ_OPTIONS: Intl.DateTimeFormatOptions = { timeZone: APP_TIMEZONE };

/** Parse API timestamps (naive UTC ISO strings or Date) into a JS Date. */
export function parseApiDate(raw: string | Date | null | undefined): Date | null {
  if (raw == null || raw === "") return null;
  if (raw instanceof Date) return isNaN(raw.getTime()) ? null : raw;

  const s = String(raw).trim();
  if (!s) return null;

  // Backend stores UTC via datetime.utcnow() — naive ISO must be read as UTC.
  const hasTimezone = /[Zz]$|[+-]\d{2}:\d{2}$/.test(s);
  const normalized = hasTimezone ? s : s.includes("T") ? `${s}Z` : s;
  const d = new Date(normalized);
  return isNaN(d.getTime()) ? null : d;
}

export function formatInRome(
  raw: string | Date | null | undefined,
  options: Intl.DateTimeFormatOptions
): string | null {
  const d = parseApiDate(raw);
  if (!d) return null;
  return new Intl.DateTimeFormat(APP_LOCALE, { ...TZ_OPTIONS, ...options }).format(d);
}

/** e.g. 09 giu 2026 */
export function formatDateRome(raw: string | Date | null | undefined): string | null {
  return formatInRome(raw, { day: "2-digit", month: "short", year: "numeric" });
}

/** e.g. 09 giugno 2026 */
export function formatDateLongRome(raw: string | Date | null | undefined): string | null {
  return formatInRome(raw, { day: "2-digit", month: "long", year: "numeric" });
}

/** e.g. 09/06/2026, 14:30 */
export function formatDateTimeRome(raw: string | Date | null | undefined): string | null {
  return formatInRome(raw, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Current clock time in Rome — e.g. 14:30 */
export function formatTimeNowRome(): string {
  return new Intl.DateTimeFormat(APP_LOCALE, {
    ...TZ_OPTIONS,
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date());
}

/** Current calendar year in Rome (for default form values). */
export function getCurrentYearRome(): number {
  const year = new Intl.DateTimeFormat(APP_LOCALE, {
    ...TZ_OPTIONS,
    year: "numeric",
  }).format(new Date());
  return parseInt(year, 10);
}
